<cx-abstract [component]="components | cmsComponent: CX_COMPONENT.PARAGRAPH" />
